/* eslint-disable @typescript-eslint/no-unused-vars */
import { checkValue } from 'src/components/common/helper';
import styled, { css } from 'styled-components';

export const HeroBackgroundImage = styled.div<{ imageSrc: string; bgColor: string }>`
  ${({ imageSrc = '', bgColor = '' }) => {
    return css`
      position: absolute;
      height: 100%;
      width: 100%;
      ${checkValue(bgColor) ? `background-color: ${bgColor};` : ''}
      ${checkValue(imageSrc) && !checkValue(bgColor)
        ? `
        background: url(${imageSrc}) ;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        object-fit: cover;
        z-index:1;
      `
        : ''}
    `;
  }}
`;
